var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUpb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1964.8 662.6",
    style: {
      enableBackground: "new 0 0 1964.8 662.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.6574,
    y1: 331.315,
    x2: 1908.1027,
    y2: 331.315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF003D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#AD3DFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,604.2c41.5,33.4,102.4,50.1,182.7,50.1h-245V457C56.7,521.8,77.4,570.8,119,604.2z M265.2,547.7 c23.7,21.5,59.1,32.2,106.1,32.2c49,0,87.7-11.9,115.9-35.6c28.2-23.7,42.3-56.4,42.3-98.2V8.3H229.7v443.3 C229.7,494.2,241.5,526.3,265.2,547.7z M424.4,635.1c-37.9,12.8-78.8,19.3-122.7,19.3h228.6l0.5-77.1 C497.8,603,462.3,622.3,424.4,635.1z M818.6,405.3c15.6,14.2,41.6,21.2,78,21.2c52.9,0,95-15.3,126.5-45.8 c31.5-30.6,47.3-71.7,47.3-123.6c0-59.9-20.6-106.4-61.8-139.8c-41.2-33.4-99-50-173.2-50h-40.1v265.7 C795.2,367,802.9,391.1,818.6,405.3z M1166.9,412.7c-63,44.6-141.9,66.9-236.6,66.9c-25.8,0-49.9-1.3-72.3-4.1 c-22.4-2.8-43.4-7.1-62.8-12.9v191.9h466.3V243.5C1261.4,311.7,1229.9,368.1,1166.9,412.7z M869.7,8.3 c123.3,0,219.5,20.8,288.3,62.3c68.9,41.5,103.3,99.2,103.3,172.9V8.3H869.7z M1724.3,445.3c0-48.4-18-85.8-54.1-112 c-36.1-26.2-87.5-39.4-154.5-39.4H1441v301.4h64.4c72.9,0,127.7-12.5,164.2-37.5C1706.1,532.8,1724.3,495.3,1724.3,445.3z  M1601.4,89.5c-25.8-14-63.5-21-113.4-21h-47v165.2h58c45.5,0,80.4-7.2,104.7-21.4c24.2-14.3,36.4-34.7,36.4-61.4 C1640,123.9,1627.1,103.4,1601.4,89.5z M1538.2,8.3c90.7,0,158.7,11.1,204,33.3c45.4,22.2,68,55.3,68,99.4 c0,28.4-14.5,52.9-43.6,73.5c-29,20.7-69.2,34.7-120.3,42.1c82,6.2,146.1,25.9,192.4,59.1c46.2,33.3,69.3,76.4,69.3,129.6V8.3 H1538.2z M1819.2,596.7c-59.3,38.5-137.1,57.7-233.2,57.7h322.2V445.3C1908.1,507.7,1878.4,558.2,1819.2,596.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpb);
export default __webpack_public_path__ + "static/media/logo-upb.6386d9a664c8708d9b1885cfcdaa556b.svg";
export { ForwardRef as ReactComponent };